import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-extended-profile',
  templateUrl: './extended-profile.component.html',
  styleUrls: ['./extended-profile.component.scss']
})
export class ExtendedProfileComponent implements OnInit {
  @HostListener("click") onClick(){
    this.checkRoute();
  }
  fullWidth=false;
  showSideMenu = true;
  // showHeading = false;
  constructor() { }

  ngOnInit(): void {
    this.checkRoute();
  }

  splitUrl(){
    let url=location.pathname.split('/');
    // console.log(url);
    if(url.length === 4 || (url.length===5 &&(url[4]==='2-1'))){
      this.showSideMenu=true;
      this.fullWidth=false;
      // this.showHeading = true;
    }
    else{
      this.showSideMenu=false;
      this.fullWidth=true;
    }
  }
  checkRoute(){
    setTimeout(()=>{
      this.splitUrl();
    })
  }
}
